import { __awaiter } from '../_virtual/_tslib.js';

function sleep(timeInMs) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((res) => setTimeout(() => {
            res(1);
        }, timeInMs));
    });
}

export { sleep };
//# sourceMappingURL=sleep.js.map
